



















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import * as rules from '@/rules'
import ValueTypes from "@/utils/ValueTypes";

@Component({
    components: {}
})

export default class ListInput extends Vue {

    @Prop({default: '', type: String})
    placeholder!: string;

    @Prop({default: '', type: String})
    hint!: string;

    @Prop({default: '', type: String})
    label!: string;

    @Prop({default: false, type: Boolean})
    dialog!: boolean;

    @Prop({default: false, type: Boolean})
    factor!: boolean;

    @Prop({default: false, type: Boolean})
    isListActive!: boolean;

    @Prop({default: false, type: Boolean})
    addToList!: boolean;

    private list: string = '';
    private items = ValueTypes.FACTOR_OPTIONS.filter(val => !val.name.toLowerCase().includes('Table'.toLowerCase()));
    private factorType = "NONE"
    private addToListInternal = false;
    requiredRule = [
        rules.REQUIRED
    ];

    $refs!: {
        form: HTMLFormElement
    };

    created() {
        document.addEventListener('keydown', this.keyActions, true);
    }

    beforeDestroy() {
        document.removeEventListener('keydown', this.keyActions, true);
    }

    private keyActions(e: any) {
        if (this.dialog) {
            if (e.key == 'Enter' && e.altKey) {
                this.submit();
            }
        }
    }

    get isDisabled() {
        if (this.list!==undefined && this.list.trim()) {
            return false;
        } else {
            return true;
        }
    }

    @Watch('dialog')
    dialogChange() {
        if (!this.list) {
            this.$refs.form.reset();
        }
        this.addToListInternal = this.addToList
    }

    private submit() {
        if (this.list) {
            let type = this.factorType;
            let listArray: any[] = this.list.split(/\r?\n/);
            listArray.forEach((item, index) => {
                if (item.trim().length) {
                    listArray[index] = item.trim();
                }
            }, listArray);
            this.list = '';
            this.$refs.form.reset();
            let res: any[]= listArray.filter( (item:string) => {
                return !!item;
            });
            if(this.factor) {
                this.$emit('submit', {names: res, type: type, addToList: this.addToListInternal})
                return
            }
            this.$emit('submit', {names: res, addToList: this.addToListInternal});
        }
    }

    private cancel() {
        this.list = '';
        this.$refs.form.reset();
        this.$emit('cancel');
    }

}

